import React from 'react';
import apiclient from 'lib/apiclient';
import useAreas from 'hooks/useAreas';
import useSalesCoordinators from 'hooks/useSalesCoordinators';
import useSupportCoordinators from 'hooks/useSupportCoordinators';
import { useHistory } from 'react-router-dom';
import { Form, FormGroup, Label, Input, Button } from 'reactstrap';
import { Formik, Form as FormikForm, Field} from 'formik';

const Table = (props) => {
  const areas = useAreas();
  const salesCoordinators = useSalesCoordinators();
  const supportCoordinators = useSupportCoordinators();
  const {
    detail,
    onSubmit: handleSubmit
  } = props;

  return (
    <Formik initialValues={detail} onSubmit={handleSubmit}>
      <Form tag={FormikForm}>
        <FormGroup>
          <Label for="managementNumber">課金データ管理番号</Label>
          <Input tag={Field} id="managementNumber" name="managementNumber" placeholder="課金データ管理番号" />
        </FormGroup>
        <FormGroup>
          <Label for="name">顧客名</Label>
          <Input tag={Field} id="name" name="name" placeholder="例：ユニテックシステム株式会社" />
        </FormGroup>
        <FormGroup>
          <Label for="area">エリア</Label>
          <Input tag={Field} as="select" id="area" name="areaId">
            <option value=""></option>
            {areas.map(value => <option key={value.id} value={value.id}>{value.name}</option>)}
          </Input>
        </FormGroup>
        <FormGroup>
          <Label for="salesCoordinator">営業担当者</Label>
          <Input tag={Field} as="select" id="salesCoordinator" name="salesCoordinatorId">
            <option value=""></option>
            {salesCoordinators.map(value => <option key={value.id} value={value.id}>{value.name}</option>)}
          </Input>
        </FormGroup>
        <FormGroup>
          <Label for="supportCoordinator">サポート担当者</Label>
          <Input tag={Field} as="select" id="supportCoordinator" name="supportCoordinatorId">
            <option value=""></option>
            {supportCoordinators.map(value => <option key={value.id} value={value.id}>{value.name}</option>)}
          </Input>
        </FormGroup>
        <FormGroup check>
          <Label check><Input tag={Field} type="checkbox" name="useToken" />{' '}トークン付きURLを使用(旧仕様)</Label>
        </FormGroup>
        <FormGroup check>
          <Label check><Input tag={Field} type="checkbox" name="isFreeTrial" />{' '}体験版</Label>
        </FormGroup>
        <FormGroup check>
          <Label check><Input tag={Field} type="checkbox" name="isDemo" />{' '}デモ版</Label>
        </FormGroup>
        <Button>保存</Button>
      </Form>
    </Formik>
  );
}

export default (props) => {
  const [data, setData] = React.useState({});
  const history = useHistory();

  const id = props.match && props.match.params && props.match.params.id;
  const handleSubmit = React.useCallback((model) => {
    apiclient.put(`api/customer/${id}`, model)
      .then(() => {
        history.goBack();
      });
  }, [id]);

  React.useEffect(() => {
    apiclient.get(`api/customer/${id}`)
      .then(response => {
        setData({ detail: response.data, loaded: true });
      });
  }, [id]);

  const contents = data.loaded
    ? <Table detail={data.detail} onSubmit={handleSubmit} />
    : <p><em>Loading...</em></p>;

    return (
      <div>
        <h1 id="tabelLabel" ><span onClick={() => history.goBack()}>顧客一覧</span> &#12297; {id}</h1>
        {contents}
      </div>
    );
}